import {configureStore} from "@reduxjs/toolkit";
import idiomaReducer from "./idiomaReducer";

const store = configureStore({
    reducer: {
        idioma: idiomaReducer
    }
})

export default store